<template>
    <div class="d-block" style="width: 1392px; margin: auto;">
        <Card :bordered="false">
            <div class="d-flex justify-start">
                <div class="d-block">
                    <RadioGroup v-model="type" type="button" button-style="solid" @on-change="getAnomaly">
                        <Radio class="width-80 al-center" :label="1">初筛</Radio>
                        <Radio class="width-80 al-center" :label="2">复筛</Radio>
                        <Radio class="width-80 al-center" :label="3">诊断</Radio>
                    </RadioGroup>
                </div>
                <span class="d-flex-item"/>
                <div class="d-block">
                    <button class="btn btn-icons btn-warning" @click="onPrint">
                        <img src="static/icon/print-white@16px.png"/>
                    </button>
                </div>
            </div>
        </Card>

        <br/>

        <Card :bordered="false">
            <div class="print-root" style="margin: 0;" :style="{height: $common.content.height - 214 + 'px'}">
                <div class="d-block" ref="print-main">
                    <div class="print-page horizontal">
                        <h1>0～6岁儿童心理行为发育初筛异常登记表</h1>
                        <hr/>
                        <div class="d-flex justify-center" style="width: 80%; margin: auto; font-size: 18px; font-weight: bold;">
                            <input class="d-flex-item line" type="text"/> 省
                            <input class="d-flex-item line" type="text"/> 市（州）
                            <input class="d-flex-item line" type="text"/> 县（市、区）
                            <input class="d-flex-item line" type="text"/> 乡（镇、社区）
                            <input class="d-flex-item line" type="text"/> 机构
                        </div>
                        <br/>
                        <table border hover>
                            <tr no-hover>
                                <th>序号</th>
                                <th>编号</th>
                                <th>儿童姓名</th>
                                <th>性别</th>
                                <th>家长姓名</th>
                                <th>联系电话</th>
                                <th>家庭住址</th>
                                <th>初筛日期</th>
                                <th>初筛结果</th>
                                <th v-if="type === 3">初筛结果</th>
                            </tr>
                            <tr v-for="(it, i) in tableData" :key="i">
                                <th>{{ i + 1 }}</th>
                                <td>{{ it.serialNumber }}</td>
                                <td>{{ it.name }}</td>
                                <td>{{ $common.sex.find(e => e.value === it.sex).text }}</td>
                                <td>{{ it.parentName }}</td>
                                <td>{{ it.phone }}</td>
                                <td>{{ it.homeAddress }}</td>
                                <td>{{ $moment(it.checkDate).format('YYYY-MM-DD') }}</td>
                                <td>
                                    <ul>
                                        <li v-for="t in it.abnormalityResults">{{ t }}</li>
                                    </ul>
                                </td>
                                <td v-if="type === 3">
                                    <ul>
                                        <li v-if="it.recoveryAdvice1 === 1">家庭干预</li>
                                        <li v-if="it.recoveryAdvice2 === 1">社区干预（基层医疗卫生机构）</li>
                                        <li v-if="it.recoveryAdvice3 === 1">机构干预</li>
                                        <li v-if="it.recoveryAdvice4 !== ''">其他 <input class="line" type="text" readonly v-model="it.recoveryAdvice4"/></li>
                                    </ul>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script type="text/javascript">
    import PrintJS from 'print-js'

    export default {
        components: {},
        data(){
            return {
                type: 1,
                tableData: [],
                tableColumns: [],
            }
        },
        async mounted() {
            await this.getAnomaly();
        },
        methods: {
            async getAnomaly(){
                this.$Spin.show();
                let res = await this.$api.getHttp('abnormality/' + this.type);
                this.$Spin.hide();
                console.log('this.getAnomaly---------->', res);
                if (res.data.code !== 0){
                    return await this.$common.alertModel('error', res.data.msg);
                }
                this.tableData = res.data.data;
            },
            async onPrint(){
                return await PrintJS({
                    printable: this.$refs["print-main"],
                    type: 'html',
                    maxWidth: '1360',
                    honorColor: true, // 是否彩色打印
                    style: '@page{size: 297mm 210mm; margin: 0; padding: 48px;} body{margin: 0; padding: 0;}',
                    scanStyles: true,
                    css: '', // 如 ../style.css
                    targetStyles: ['*'], // *代表应用所有样式，默认值为null，如果不设置，打印窗口则会忽略所有样式
                    font_size: '999', // 解决字体大小问题
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/pages/anomaly/index.vue